import { Action, ActionType } from "@redux/actionTypes/apiDevelopmentToolingActionType";
import { Reducer } from "react";

export interface IAPIDevToolingState {
  apiDevToolingDetailsByPID: IAPIDevToolingDetailsByPID[];
}

export interface IAPIDevToolingDetailsByPID {
  projectId: number;
  projectName: string;
  toolingCapexData: ITableData;
}
export interface Iheaders {
  headName: string;
  value: string;
  classname?: string;
  separator?: string;
}
export interface ITableData {
  headers: Iheaders[];
  tableData: Record<string, any>[];
  totalObject: Record<string, any>[];
}

const initialState = {
  apiDevToolingDetailsByPID: [],
};

export const apiDevelopmentToolingReducer: Reducer<IAPIDevToolingState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.API_DEV_TOOLING_DETAILS_BY_PID:
      return {
        ...state,
        apiDevToolingDetailsByPID: action.payload,
      };
    case ActionType.RESET_REDUX_STATE: {
      return initialState;
    }
    default:
      return state;
  }
};
